module.exports = __webpack_public_path__ + "img/vino-logo-light.24fe83ec.svg";